import React, { useEffect, useState } from 'react';
import { Bounce, toast } from 'react-toastify';
import { InputBox } from '../_components/InputBox';
import Loading from '../_components/Loading';
import { Path } from '../_components/Path';
import { apiConstants } from '../_constants';
import { miscService, validateEmail, validateFileSize } from '../_services/misc.service';
import { userService } from '../_services/user.service';
import './profile.css';

export default function Profile() {
  const [stateData, setStateData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState({});
  const [isEditable, setIsEditable] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const checkUser = async () => {
      try {
        setIsLoading(true);
        const userString = localStorage.getItem('user');
        let parsedData = JSON.parse(userString);
        userService.usersList({ _id: parsedData._id }).then((res) => {
          setIsLoading(false);
          if (res?.data?.rows?.length > 0) {
            setUserData(res?.data?.rows[0]);
          }
        });
      } catch (error) {
        console.log(
          '----------------profileuserrrr--rrrrrrrrrrrrrr------------------------',
          error,
        );

        setIsLoading(false);
        userService.logout();
      }
    };
    checkUser();
  }, []);
  useEffect(() => {
    // Fetch the JSON file from the public folder
    fetch('/state.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((jsonData) => {
        const transformedData = {};
        jsonData.forEach((entry) => {
          const state = entry.State;
          const district = entry.District;
          // Create an array of districts for each state
          if (!transformedData[state]) {
            transformedData[state] = [];
          }
          transformedData[state].push(district);
        });
        setStateData(transformedData);
      })
      .catch((error) => {
        console.error('Error fetching the JSON file:', error);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name == 'state' || name == 'district') {
      let { address } = userData;
      if (name == 'state') {
        setUserData({ ...userData, address: { [name]: value, district: '' } });
      } else {
        setUserData({ ...userData, address: { ...address, [name]: value } });
      }
    } else {
      setUserData({ ...userData, [name]: value });
    }
  };

  const handleSubmit = (user) => {
    setSubmitted(true);
    if (user.first_name && user.last_name && user.email && user.phone) {
      setIsLoading(true);
      console.log('valssss', error);
      if (validateEmail(user.email)) {
        userService.saveUser(user).then(
          (res) => {
            setIsLoading(false);
            setSubmitted(false);

            // navigate('/');
            console.log(res, 'ths is response');
          },
          (err) => {
            setIsLoading(false);
            setSubmitted(false);

            console.log(err, 'thi si ser');
            //   setError(err);
          },
        );
      } else {
        setIsLoading(false);
        setError('Enter valid email');
      }
    } else {
      setIsLoading(false);
      setError('Please complete the form');
    }
  };

  const uploadFile = async (event) => {
    const file = event?.target?.files[0];
    if (await validateFileSize(file?.size)) {
      miscService.fileupload(file, file.name).then(
        (res) => {
          if (res?.data) {
            userData.profile_image = res.data;
            setUserData(userData);
            handleSubmit(userData);
          }
        },
        (err) => {
          console.log(err, 'this is err value');
        },
      );
    } else {
      toast.error('Image size should be less than 2 MB', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
        transition: Bounce,
      });
    }
  };
  return (
    <div className='container'>
      <Path pathList={[{ name: 'My Profile' }]} />

      <div className='d-flex '>
        <div className='profiledetailccontainer col-md-6'>
          <div className='headsection'>
            <img src='/img/profile_header_img.png' className='headerimg' />
          </div>

          <div className='form-group  d-flex flex-column gap-3 formcontainer'>
            <div className='mb-3'>
              <div className='profileimagecontainer  d-flex justify-content-center '>
                <label htmlFor='fileInput' className='uploadicon'>
                  {userData?.profile_image ? (
                    <img
                      src={apiConstants.imgUrl + userData?.profile_image}
                      className='user_profile_icon'
                    />
                  ) : (
                    <img src='/img/camera_icon.png' className='camicon' />
                  )}
                </label>
                <input
                  type='file'
                  id='fileInput'
                  accept='image/*'
                  onChange={uploadFile}
                  style={{ display: 'none' }}
                />
              </div>
              <label className='prfileupdatelbl' htmlFor='fileInput'>
                {' '}
                Change Profile Image{' '}
              </label>
            </div>

            <InputBox
              type='number'
              label='Phone'
              name='phone'
              value={userData?.phone}
              placeholder='Phone Number'
              onChange={handleChange}
              submitted={submitted}
              disabled={!isEditable}
            />
            <InputBox
              type='text'
              label='First Name'
              name='first_name'
              value={userData?.first_name}
              placeholder='First Name'
              onChange={handleChange}
              submitted={submitted}
              disabled={!isEditable}
            />
            <InputBox
              type='text'
              label='Last Name'
              name='last_name'
              value={userData?.last_name}
              placeholder='Last Name'
              onChange={handleChange}
              submitted={submitted}
              disabled={!isEditable}
            />
            <InputBox
              type='email'
              label='Email'
              name='email'
              value={userData?.email}
              placeholder='name@example.com'
              onChange={handleChange}
              submitted={submitted}
              disabled={!isEditable}
            />
            <InputBox
              type='text'
              label='Education'
              name='education'
              value={userData?.education}
              placeholder=''
              onChange={handleChange}
              disabled={!isEditable}
            />
            <InputBox
              type='text'
              label='Institution'
              name='college'
              value={userData?.college}
              placeholder='Eg: MG University'
              onChange={handleChange}
              disabled={!isEditable}
            />

            <div className='inputcontainer'>
              <div className='input_label'>State</div>
              <select
                className='select_input'
                name='state'
                onChange={handleChange}
                value={userData?.address?.state}
                disabled={!isEditable}
              >
                <option value=''>Select One</option>
                {Object.keys(stateData).map((item, index) => {
                  return (
                    <option value={item} key={index}>
                      {item}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className='inputcontainer'>
              <div className='input_label'>District</div>
              <select
                className='select_input'
                onChange={handleChange}
                name='district'
                value={userData?.address?.district}
                disabled={!isEditable}
              >
                <option value=''>Select One</option>
                {stateData?.[userData?.address?.state]?.map((district, index) => {
                  return (
                    <option value={district} key={index}>
                      {district}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className=' d-flex justify-content-center'>
              <div
                className='savebtn'
                onClick={() => {
                  if (isEditable) {
                    handleSubmit(userData);
                  } else {
                    setIsEditable(true);
                  }
                }}
              >
                {isLoading ? <Loading /> : isEditable ? 'Save' : 'Edit Details'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
